import EncryptionService from "../services/EncryptionService.js";

const ElectionMixin = {
  methods: {
    affiliationSelected(evt) {
      var found = false;
      if (evt.value === true) {
        this.listVoted.forEach((list, index) => {
          if (list.id === evt.id) {
            this.listVoted[index] = evt;
            found = true;
          }
        });
        if (!found) this.listVoted.push(evt);
      }
      if (evt.value === false)
        this.listVoted = this.listVoted.filter(item => item.id !== evt.id);
      if (evt.hasPreferences === true) {
        this.hasPreferences = true;
      }

      if (evt.hasPreferences === true && evt.value === true) {
        this.readAriaLive = false;
      } else {
        this.readAriaLive = true;
      }
      this.checkIfReady();
      this.$forceUpdate();
    },
    affiliationConfirmed(evt) {
      var found = false;
      if (evt.value === true) {
        this.listVoted.forEach((list, index) => {
          if (list.id === evt.id) {
            this.listvoted[index] = evt;
            found = true;
          }
        });
        if (!found) this.listVoted.push(evt);
      }
      if (evt.value === false)
        this.listVoted = this.listVoted.filter(item => item.id !== evt.id);
      this.checkIfReady();
    },

    checkIfReady() {
      var ready = false;
      if (this.listOrCandidates === "CANDIDATES") {
        ready =
          1 <= this.voted.length &&
          this.voted.length <= this.election.Election[0].MaxVotes;
        this.atLeastOne = 1 <= this.voted.length;
        this.tooMany = this.voted.length >= this.election.Election[0].MaxVotes;
        this.ready = ready;
        return;
      }
      if (this.listOrCandidates === "AFFILIATIONS") {
        this.ready =
          1 <= this.listVoted.length &&
          this.listVoted.length <= this.election.Election[0].MaxVotes;
        this.atLeastOne = 1 <= this.listVoted.length;
        this.tooMany =
          this.listVoted.length >= this.election.Election[0].MaxVotes;
      }
    },
    vote() {
      if (
        (this.voted.length < this.election.Election[0].MaxVotes &&
          this.listOrCandidates === "CANDIDATES") ||
        (this.listVoted.length < this.election.Election[0].MaxVotes &&
          this.listOrCandidates === "AFFILIATIONS")
      ) {
        if (
          this.voted.length < this.totCandidatesOrAffiliations &&
          this.listOrCandidates === "CANDIDATES"
        ) {
          this.confirmVoteDialog = true;
        } else if (
          this.listVoted.length < this.totCandidatesOrAffiliations &&
          this.listOrCandidates === "AFFILIATIONS"
        ) {
          this.confirmVoteDialog = true;
        } else {
          this.openFinalConfirm = true;
        }
      } else {
        this.openFinalConfirm = true;
      }
    },
    async finalConfirmationVote() {
      let encryptionService = new EncryptionService(
        this.$store.state.ceoCbbService,
        this.election.Election[0].ElectionVotingContest.ElectionCertificate,
        this.election.Election[0].ElectionVotingContest.CountingCertificate
      );
      let candidates = this.voted.map(candidate => {
        return candidate;
      });
      let affiliations = this.listVoted.map(aff => {
        return aff;
      });

      let bsr = await encryptionService.sendVote(
        {
          EventName: this.$store.state.electionEvent.ElectionEvent
            .EventIdentifier.EventName,
          Id: this.$store.state.electionEvent.ElectionEvent.EventIdentifier.Id
        },
        this.election.Election[0].ElectionIdentifier,
        this.$store.state.voterIdentification.Voter.VoterIdentifier,
        candidates,
        affiliations,
        this.voteBlank ? this.election.Election[0].NoChoiceIdentifier : null,
        this.voteNull ? this.election.Election[0].NullChoiceIdentifier : null
      );
      if (bsr == "yes") {
        this.voteSent = true;
        this.openFinalConfirm = false;
        this.$emit("closeElection", this.electionId);
      } else {
        //console.log(bsr);
        alert(this.$i18n.t("error.send-vote") + this.$store.state.alertMessage);
      }
    },
    // changeTab(evt) {
    //   if (evt != "page0" && evt != undefined) this.changed = true;
    // },
    // changeTab(evt) {
    //   if (evt != "page0" && evt != "page1" && evt != undefined) {
    //     this.changed = true;
    //     let found;
    //     this.orderedContests.forEach(el => {
    //       if (el.name == evt) found = true;
    //     });
    //     if (!found && !this.contestNames[evt]) {
    //       this.loaded = false;
    //     }
    //     this.contestNames[evt] = true;

    //     this.$forceUpdate();
    //   }
    // },
    finalConfirmationCancel() {
      this.openFinalConfirm = false;
      this.voteBlank = false;
      this.voteNull = false;
    },
    candidateSelected(evt) {
      this.voted = this.voted.filter(
        item =>
          item.candidate.CandidateIdentifier.Id !==
          evt.candidate.CandidateIdentifier.Id
      );
      if (evt.value === true) {
        this.voted.push(evt);
      }
      this.checkIfReady();
      //   if (this.isMobile) this.showAll = false;
    },
    async makeAbstention() {
      // console.log("electionid");
      // console.log(this.electionId);
      let abstention = await this.$store.state.ceoCbbService.makeAbstention(
        this.electionId,
        this.$store.state.electionEvent.ElectionEvent.EventIdentifier.Id,
        this.$store.state.voterIdentification.Voter.VoterIdentifier.VoterId[0]
      );
      // console.log(abstention);
      if (abstention.randomUsername) {
        // console.log("invio a cbb la richiesta di cancellazione");
        let result = await this.$store.state.ceoCbbService.ballotDelete(
          this.electionId,
          this.$store.state.electionEvent.ElectionEvent.EventIdentifier.Id,
          abstention.randomUsername,
          abstention.randomPassword
        );
        // console.log(result);
        if (result.Accepted == "yes") {
          this.openFinalConfirm = false;
          this.$emit("closeElection", this.electionId);
        } else {
          alert(
            this.$i18n.t("error.send-vote") + this.$store.state.alertMessage
          );
        }
      }
    },
    labelContesto(contesto, from, to) {
      if (contesto == null) {
        return ".";
      }
      var res = contesto.split("-");
      if (res.length > 1) {
        //res = "da " + res[0] + " a " + res[1] + ". ";
        res = from + " " + res[0] + " " + to + " " + res[1] + ". ";
      } else {
        res =
          this.$i18n.locale == "de"
            ? ", " + res[0] + ". "
            : "in " + res[0] + ". ";
      }
      return res;
    }
  },
  computed: {
    sexVoted() {
      if (this.electionType === "NORMAL") return 0;
      let n = null;
      if (this.electionType === "AIDED_EQUAL_OPPORTUNITIES") n = 2;
      if (this.electionType === "AIDED_THREE_EQUAL_OPPORTUNITIES") n = 3;
      let sexVoted = this.voted.map(vote => {
        return vote.gender;
      });
      return this.utils.checkEqualOpp2(
        n,
        sexVoted,
        this.election.Election[0].MaxVotes
      );
    }
  }
};

export default ElectionMixin;
